import React from "react";

function Partners() {
  return (
    <section id="partners" className="px-5   ">
        <h1 className="text-center display-3" data-aos="fade-down">
            Our Beloved Partners <i class="bi bi-chat-heart text-danger"></i>
        </h1>
      <div className="row" >
       
        <div className="col-12 " >
          <div className="row">
            <div className="col-2" >
              <img
                src={`${process.env.PUBLIC_URL}/images/partner-1.png`}
                className="img-fluid"
                alt="..."
              />
            </div>
            <div className="col-2 d-flex align-items-center"> <img
                src={`${process.env.PUBLIC_URL}/images/partner-2.png`}
                className="img-fluid "
                alt="..."
              /></div>
            <div className="col-2">
            <img
                src={`${process.env.PUBLIC_URL}/images/partner-3.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2">
            <img
                src={`${process.env.PUBLIC_URL}/images/partner-4.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2">
            <img
                src={`${process.env.PUBLIC_URL}/images/partner-5.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/partner-6.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/partner-7.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2">
            <img
                src={`${process.env.PUBLIC_URL}/images/partner-8.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/shriram.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/dbs.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/LoanTap.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/bf.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            
            <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/muthoot.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div> <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/chola.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div> <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/indusind.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div> <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/incred.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div> <div className="col-2 d-flex align-items-center">
            <img
                src={`${process.env.PUBLIC_URL}/images/Tata.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div> <div className="col-2">
            <img
                src={`${process.env.PUBLIC_URL}/images/bandhan.png`}
                className="img-fluid"
                alt="..."
              /> 
            </div>
            
            
            
            
 
            
          </div>
        </div>
        
      </div>
      
    </section>
  );
}

export default Partners;
